export interface IHookConfig {
  url: string;
  secret?: string;
  header?: string;
}

export interface IHook {
  id: string;
  active: boolean;
  confirmed: boolean;
  events: HookEvents[];
  config: IHookConfig;
  owner_id: string;
  tenant_id: string;
  tenant_name: string;
  created_at: Date;
  updated_at: Date;
  wildcard: boolean;
}

export interface IHookPayload {
  id?: string;
  active: boolean;
  url: string;
  secret?: string;
  header?: string;
  events: HookEvents[];
}

export enum WildCardEvent {
  ALL = '*',
}

export enum QuestionSetEvents {
  Completed = 'question_set:completed',
}

export enum QuoteRequestEvents {
  Finished = 'quote_request:finished',
  Selected = 'quote_request:selected',
}

export enum ApplicationFormEvents {
  ExchangeBorrow = 'application_form:exchange_borrow',
  ExchangeBorrowReturn = 'application_form:exchange_borrow_return',
  ExchangeMatch = 'application_form:exchange_match',
  FinishedQuoting = 'application_form:finished_quoting',
  Inactive = 'application_form:inactive',
  TakenOver = 'application_form:taken_over',
  TransferredIntoTenant = 'application_form:transferred_into_tenant',
  TransferredToWholesaler = 'application_form:transfer_to_wholesaler'
}

export enum CarrierEvents {
  BridgedToOffPlatformCarrier = 'carrier:bridged_to_off_platform_carrier'
}

export type HookEvents = WildCardEvent | QuestionSetEvents | QuoteRequestEvents | ApplicationFormEvents | CarrierEvents;

export interface IHookRequest {
  id: string;
  application_form_id: string;
  reference_id: string;
  tenant_id: string;
  delivery_id: string;
  event: HookEvents;
  enqueued_at: Date;
  redelivery: boolean;
  hook_id: string;
  created_at: Date;
  updated_at: Date;
  response_status: number;
  response_duration_ms: number;
}
